export default __webpack_public_path__ + "static/media/4.b4929673.jpg";